import {useEffect} from 'react'

import {transferSelector} from '../../data/transfers.js'
import Modals from '../TransferListPage/Modals/index.js'
import {
  transferDetailFormSelector,
  transferDetailTransferIDSelector,
} from './transferDetailFunctions.js'
import {hasTransferPermissionSelector} from '../../data/me.js'
import NoPermissionsPage from '../NoPermissionsPage.js'
import {onlyIfForm, useSelector} from '../../store.js'
import Sidebar from './Sidebar.js'
import List from './List.js'
import ListItemsCount from '../../common/components/List/ListItemsCount.js'
import {plural} from '../../common/components/Plural.js'
import {navigateToTransferListPage} from '../TransferListPage/transferListFunctions.js'

function TransferDetailPage({form}) {
  const transferID = useSelector(transferDetailTransferIDSelector)
  const transfer = useSelector((state) => transferSelector(state, {transferID}))
  const hasTransferPermission = useSelector(hasTransferPermissionSelector)

  useEffect(() => {
    document.title = transferID ? `${transferID} - Transfer` : 'Transfer'
  }, [transferID])

  if (!hasTransferPermission) {
    return <NoPermissionsPage />
  }

  if (!transferID) {
    return null
  }

  if (form.isLoading) {
    return (
      <div className="margin-top-40">
        <div className="loading align-center">
          <span className="list-processing animate-spin v-align-middle" />
          <strong className="inline-block v-align-middle fs-02 op-75 margin-left-5">
            Loading...
          </strong>
        </div>
      </div>
    )
  }

  if (!transfer) {
    return (
      <dl className="list--empty-content">
        <dt className="fs-02 margin-bottom-20">
          <span>Transfer ‘{transferID}’ could not be found</span>
        </dt>
      </dl>
    )
  }

  const count = transfer.lines.length

  return (
    <div id="iverson-page">
      <Modals />
      <div className="wrap--container">
        <div className="wrap--row">
          <div className="medium-12 columns">
            <div className="wrap--list-header padding-top-10 padding-bottom-10">
              <ul className="list list--no-style">
                <li className="inline-block margin-right-3">
                  <button
                    className="btn btn--action v-align-base"
                    type="button"
                    onClick={() => navigateToTransferListPage()}
                  >
                    ← Transfers
                  </button>
                </li>
                <li className="inline-block divider--left">
                  <ListItemsCount
                    count={count}
                    thing={plural(count)`SKU${['s']}`}
                  />
                </li>
              </ul>
              <hr className="hr--detail-page margin-top-15"></hr>
            </div>
          </div>
        </div>
        <div className="wrap--row margin-top-20">
          <div className="medium-8 columns">
            <List />
          </div>
          <div className="columns medium-4">
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  )
}

export default onlyIfForm(TransferDetailPage, transferDetailFormSelector)
